import React from 'react';
import { FormGroup, Input, Row, Col } from 'reactstrap';

const Select = ({handleSelectChange, questionData}) => {
    return(
        <FormGroup className='mb-5'>
            <Row>
                <Col xs="2" className='text-center pe-0 pt-1'><span className='select-free-lable'>{questionData.order}</span></Col>
                <Col xs="10" className='ps-0 free-question-lable'>{questionData.title}</Col>
            </Row>
            <Input value={questionData.preSelect === 'customise' ? "" : questionData.preSelect} name={questionData.order} type="select" className='free-question-select mt-3' onChange={e => handleSelectChange(e)}>
                <option value="" disabled selected hidden>Select one</option>
                { questionData.que.map(obj => <option key={obj.value} value={obj.value}>{obj.label}</option>)}
            </Input>
        </FormGroup>
    );
}

export default Select;